import React from "react";
import { UiSectionH3 } from "./UiSectionH3";
import { twMerge } from "tailwind-merge";

interface SectionProps {
  title: string;
  children?: React.ReactNode;
  section?: string;
  className?: string;
}

const UiSection: React.FC<SectionProps> = ({ title, children, className }) => (
  <div
    className={twMerge(
      "section border-t border-[#EAEEF3] py-10 text-sm sm:text-base",
      className,
    )}
  >
    {title && <UiSectionH3 title={title} />}
    {children}
  </div>
);

export default UiSection;
